// src/config/environmentConfig.js
// ATENÇÃO: clientId, clientSecret e USER_CREDENTIALS foram removidos.
// A autenticação agora é feita via OIDC Authorization Code Flow (oidc-client-ts).
// Configure as variáveis REACT_APP_IDENTITY_CENTER_* no arquivo .env
//
// A URL da API é lida de REACT_APP_FLYSHIELD_API_URL no .env.
// Os valores abaixo servem como fallback caso a variável não esteja definida.

export const ENVIRONMENTS = {
  producao: {
    label: 'Produção',
    apiBaseUrl: 'https://flyshield-api.agroverita.com.br',
  },
  staging: {
    label: 'Staging',
    apiBaseUrl: 'https://api-flyshield-stg.azurewebsites.net',
  },
  desenvolvimento: {
    label: 'Desenvolvimento',
    apiBaseUrl: 'https://api-flyshield-dev.azurewebsites.net',
  },
};

let currentEnvironment = process.env.REACT_APP_ENVIRONMENT || 'producao';

export function getCurrentEnvironment() {
  return currentEnvironment;
}

export function setCurrentEnvironment(env) {
  if (!ENVIRONMENTS[env]) throw new Error(`Ambiente inválido: ${env}`);
  currentEnvironment = env;
}

export function getCurrentConfig() {
  const config = ENVIRONMENTS[currentEnvironment];
  return {
    ...config,
    apiBaseUrl: process.env.REACT_APP_FLYSHIELD_API_URL || config.apiBaseUrl,
  };
}
